export default {
  props: {
    type: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {};
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {},
  methods: {}
};